import { render, staticRenderFns } from "./SimpleLinkList.vue?vue&type=template&id=6e172bdf&"
import script from "./SimpleLinkList.vue?vue&type=script&lang=js&"
export * from "./SimpleLinkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports